
@if (isResizable) {
  <div resizable-divider class="resizable-divider" [ngClass]="{'resizable-dragging' : isDragging}"></div>
}
<ng-content></ng-content>
